import { EndPointService } from 'src/services/api-handlers/axios';

const ROUTE = 'assessments/questions';

const list = () => EndPointService.get(`/${ROUTE}`);
const update = (id: string, data: any) => EndPointService.patch(`/${ROUTE}/${id}`, data);

export default {
    list,
    update,
};
